import { useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import { Breed, Species } from '../../peer-colab-model/PetKey/Main/Model/1_0_Initial/Backoffice/Species/PathItems';
import { OperationRequest } from '@peercolab/engine';
import { SpeciesManagement } from '../../peer-colab-model/PetKey/BackofficeFE/Client/PathItems';

interface EditBreedProps {
  species: Species;
  breed: Breed;
  patchField: <R,V>(operation: OperationRequest<unknown, R>, newValue: V, currentValue: V, revertHandler: (value: V) => void) => Promise<void>;
  onBack: () => void;
}

function EditBreed({ species, breed, patchField, onBack }: EditBreedProps) {
  const [name, setName] = useState(breed.name);

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6" gutterBottom>
          Breed Details
        </Typography>
      </Box>
      <Box sx={{ flex: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
        <TextField
          label="Breed Name"
          value={name}
          onChange={e => setName(e.target.value)}
          onBlur={() => patchField(SpeciesManagement.updateBreedName({name: name}), name, breed.name, setName)}
          sx={{ mb: 2, minWidth: 350 }}
        />
        <TextField
          label="Translation Key"
          value={breed.translationKey}
          disabled
          sx={{ mb: 2, minWidth: 350 }}
        />
      </Box>
    </Box>
  );
}

export default EditBreed;
